/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
/* eslint-disable eqeqeq */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes, { any } from 'prop-types';

import GenderFilter from '../../../../SearchPage/Filters/GenderFilter';
import UtrInputFilter from '../../../../SearchPage/Filters/UtrInputFilter';
import EventDateFilter from '../../../../SearchPage/Filters/EventDateFilter';
import AgeInputFilter from '../../../../SearchPage/Filters/AgeInputFilter';
import useIsMobile from '../../../../../components/hooks/useIsMobile';
import DivisionTypeFilter from '../../../../SearchPage/Filters/DivisionTypeFilter';
import DivisionsMoreMobileFilter from '../../../../SearchPage/Filters/DivisionsMoreMobileFilter';
import { sportTypeIds } from '../../../../../utils/eventConstants';

import styles from '../../../../ClubProfiles/club.scss';
import searchStyles from '../../../../SearchPage/search.scss';

const DivisionFilters = ({ filters, setFilters, defaultFilterValues, searchTypes, divisionStats, sportTypeId }) => {
    const [filterInputs, setFilterInputs] = useState(defaultFilterValues);
    const [filterModal, setFilterModal] = useState('');
    const wrapperRef = useRef(null);
    const { isMobileWidth } = useIsMobile();

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters]);

    const handleFilterClick = (type) => {
        setFilterModal(filterModal === type ? '' : type);
    };

    const handleClickOutside = (e) => {
        if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
            if (!e.target.classList.contains('menu-item')) { // menu item click not working when the bottom code is called, hackish way to avoid calling if menu item clicked
                undoFilterChange();
                setFilterModal('');
            }
        }
    };

    function undoFilterChange() {
        // reset (unapplied) filter changes
        setFilterInputs(filters);
    }

    // Gender filter modal
    const handleGenderClick = ({ gender }) => {
        setFilters({
            ...filters,
            gender,
        });
        setFilterInputs({
            ...filterInputs,
            gender,
        });
        setFilterModal('');
    };

    const handleFilterSubmit = () => {
        setFilters(filterInputs);
        setFilterModal('');
    };

    const handleFilterUpdate = (props, update) => {
        // only updates filter input field values, input field values have no effect on filter state, these changes don't get submitted, users have to click the apply button first
        // Filter input state is stored in 'filterInputs'
        if (!update || update === 'filterInput') {
            setFilterInputs({
                ...filterInputs,
                ...props,
            });
        }
    };

    const clearFilters = () => {
        setFilters(defaultFilterValues);
        setFilterInputs(defaultFilterValues);
        setFilterModal('');
    };

    const closeModals = () => {
        setFilterModal('');
    };

    const hasDataChanged = JSON.stringify(filters) !== JSON.stringify(defaultFilterValues);

    const commonFilterProps = {
        filters,
        filterInputs,
        handleFilterClick,
        filterModal,
        closeModals,
        handleFilterSubmit,
        handleFilterUpdate,
    };

    const {
        hasDivisionDate,
        // hasRatingLimit,
        // hasAgeLimit,
        maleCount,
        femaleCount,
        mixedCount,
        coedCount,
    } = divisionStats;

    const filterMinMaxCriteriaMet = filterInputs.utrMin > 1 || (filters.utrMax < 16 && sportTypeId === sportTypeIds.TENNIS) || (filters.utrMax < 10 && sportTypeId === sportTypeIds.PICKLEBALL);
    const divisionsMoreMobileFiltersAreActive = (filterInputs && (
        filterMinMaxCriteriaMet || filterInputs.age || !filterInputs.startDate.isSame(defaultFilterValues.startDate) || !filterInputs.endDate.isSame(defaultFilterValues.endDate)
    ));

    return (
        <div>
            <div className={`${styles.titleContainer} ${styles.filterContainer} row mt16 pt16 mb16 pb8`} ref={wrapperRef}>
                <div className={`col-12 col-md-8`}>
                    <div className={`${searchStyles.searchFilters} np nb`}>
                        <GenderFilter
                            {...commonFilterProps}
                            handleFilterUpdate={handleGenderClick}
                            showCoedOption
                            showMixedOption
                            maleCount={maleCount}
                            femaleCount={femaleCount}
                            mixedCount={mixedCount}
                            coedCount={coedCount}
                            data-testid="event-divisions.filter.gender"
                        />
                        <DivisionTypeFilter
                            {...commonFilterProps}
                            searchTypes={searchTypes}
                            data-testid="event-divisions.filter.division-type"
                        />
                        {!isMobileWidth && (
                            <>
                                <AgeInputFilter {...commonFilterProps} data-testid="event-divisions.filter.age" />
                                <UtrInputFilter
                                    {...commonFilterProps}
                                    sportTypeId={sportTypeId}
                                    data-testid="event-divisions.filter.utr-input"
                                />
                                {hasDivisionDate && (
                                    <EventDateFilter
                                        {...commonFilterProps}
                                        customDateSelectOptions={[]}
                                        minDate={defaultFilterValues.startDate}
                                        maxDate={defaultFilterValues.endDate}
                                        onlyCustom
                                        data-testid="event-divisions.filter.date"
                                    />
                                )}
                            </>
                        )}
                        <DivisionsMoreMobileFilter
                            commonFilterProps={commonFilterProps}
                            hasDivisionDate={hasDivisionDate}
                            defaultFilterValues={defaultFilterValues}
                            isActive={divisionsMoreMobileFiltersAreActive}
                            mobileOnly
                            data-testid="event-divisions.filter.more-mobile"
                        />
                        {hasDataChanged && <u className="clickable text-teal text-small text-normal no-wrap" onClick={clearFilters} data-testid="event-divisions.reset-filters-link">reset filters</u>}
                    </div>
                </div>
            </div>
        </div>
    );
};

DivisionFilters.propTypes = {
    filters: PropTypes.objectOf(any).isRequired,
    setFilters: PropTypes.func,
    defaultFilterValues: PropTypes.objectOf(any).isRequired,
    searchTypes: PropTypes.arrayOf(any).isRequired,
    divisionStats: PropTypes.objectOf(any),
    sportTypeId: PropTypes.number,
};
DivisionFilters.defaultProps = {
    setFilters: () => {},
    divisionStats: {},
    sportTypeId: sportTypeIds.TENNIS,
};

export default DivisionFilters;
